// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"cCdjE","carousel":"_2hPS0","rightArrow":"_1NOR0","leftArrow":"ab4jE","slideArrow":"_3sP75","left":"_2XFFn","carouselDots":"_1Usg1"};